import Modal from 'react-bootstrap/Modal';
import { Button } from 'react-bootstrap';
import './DeleteModal.css';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom';
import ToastrNotifi from './ToastrNotifi';
import { useState } from 'react';
import { CircularProgress, Typography } from '@mui/material';


export default function DeleteModel({ show, onHide, deleteData, onDelete, deleteBeUrl, AfterDeleteNavigate, ToastrMessage, ModelHeader, SubHeader }) {
    const navigate = useNavigate();
    const [deleting, setDelLoading] = useState(false);

    function onDelete() {
        setDelLoading(true);

        axios.delete(`${deleteBeUrl}`, {
            headers: {
                'Content-Type': 'application/json',  // Set content type to JSON
                // 'Authorization': `Bearer ${token}`   // Assuming you need authentication, pass the token
            }
        }).then(response => {
            // console.log('Page del successfully:', response.data);
            setDelLoading(false);

            if (response.data.success) {
                navigate(AfterDeleteNavigate); // Go back after showing toast
                ToastrNotifi.successToast(ToastrMessage)
            }

        }).catch(error => {
            setDelLoading(false);
            console.error('Error Deleting page:', error);
            ToastrNotifi.errorToast('Error Deleting page');
        });
    }

    return (
        <Modal
            show={show}
            onHide={onHide}
            size="md"
            className="delete-modal"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"

        >
            <Modal.Header closeButton>
                <Modal.Title className="text-danger">
                    Confirm Deletion
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className="modal-body-text">
                    {ModelHeader}
                </p>
                <p>
                    {SubHeader}<br></br>
                    <span className='text-danger fw-bold'>{deleteData.name}</span>
                </p>
            </Modal.Body>
            <Modal.Footer className="justify-content-center">
                <Button variant="secondary" onClick={onHide} className="cancel-btn">
                    Cancel
                </Button>
                <Button variant="danger" onClick={() => onDelete(deleteData.id)} className="delete-btn">
                    {deleting ? (<div className='d-flex'>
                        <Typography paddingRight={'10px'}>Deleting </Typography>
                        <CircularProgress size={'20px'} color="inherit" />
                    </div>
                    ) : ("Delete")}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}